export class RegionCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RegionCondition.attributeTypeMap;
    }
    constructor() {
    }
}
